<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <div *ngFor="let questType of questTypes">
                        <div *ngIf="questType.id == questTypeID">
                            <h2>{{'all_quest_title' | translate}} {{questType.name}} </h2>
                        </div>
                    </div>
                    <ul>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#blog">Quest</a></li>
                        <li>
                            <div *ngFor="let questType of questTypes">
                                <div *ngIf="questType.id == questTypeID">
                                    {{questType.name}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image"></div>
    </div>
</div>
<app-subscribe></app-subscribe>
<section class="blog-area ptb-100">
    <div class="container">
        <div class="row">
            <ng-template [ngIf]="totalCount > 0" [ngIfElse]="EmptyQuest">
                <div class="col-lg-3 col-md-6" *ngFor="let quest of quests">
                    <div class="single-blog-post" (click)="goQuestDetails(quest.id)">
                        <div class="image">
                            <a>
                                <img class="quest_thumbnail"
                                src="{{quest.imagePath == null ? 'http://via.placeholder.com/306x180' : quest.imagePath}}"
                                alt="Link hình sai">
                            </a>
                        </div>

                        <div class="content">
                            <ul class="post-meta">
                                <li>
                                    <div *ngFor="let area of areas">
                                        <div *ngFor="let city of cities">
                                            <div *ngIf="quest.areaId == area.id && area.cityId == city.id">
                                                <fa-icon [icon]="faLocationDot" class="icon_location"></fa-icon>
                                                {{city.name}}
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li><i class="fa fa-comments"></i>
                                    <a>
                                        <fa-icon [icon]="faStar" class="icon_star"></fa-icon>
                                        <span *ngIf="quest['totalFeedback'] != null && quest['averageStar'] != null; else feedbackNull">
                                            {{quest['averageStar']}} ({{quest['totalFeedback']}})
                                        </span>
                                        <ng-template #feedbackNull>
                                            <span>
                                                0 (0)
                                            </span>
                                        </ng-template>

                                    </a>
                                </li>
                            </ul>
                            <div class="block-ellipsis">
                                <h3><a>{{quest.title}}</a></h3>
                            </div>
                            <div class="d-flex">
                                <span class="pack_price">{{quest.price | number}} đ</span>
                                <span class="per_quest">/ Quest </span> &nbsp;
                                <span class="minutes"> · {{quest.estimatedTime}} {{'minute' | translate}} </span>
                            </div>
                            <a  class="read-more">{{'seeDetails' | translate}}</a>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #EmptyQuest>
                <label>Không tìm thấy kết quả tìm kiếm</label>
            </ng-template>
            <div *ngIf="totalCount > 8">
                <div class="col-lg-12 col-md-12">
                    <div class="pagination-area">
                        <a (click)="getPagingArrow('prev')" class="prev page-numbers"><fa-icon [icon]="faChevronLeft"></fa-icon></a>
                        <!-- <span class="page-numbers current" aria-current="page">1</span> -->
                        <!-- <a  (click)="getPaging('')" class="page-numbers current" aria-current="page">1</a> -->
                        <!-- <a routerLink="/blog" class="page-numbers">2</a>
                        <a routerLink="/blog" class="page-numbers">3</a>
                        <a routerLink="/blog" class="page-numbers">4</a> -->

                        <span *ngFor='let in of countNumberPage(totalPages); let i = index; let first = first'>
                            <a class="page-numbers" (click)="getPaging(i+1)"> {{i+1}} </a>
                        </span>

                        <a (click)="getPagingArrow('next')" class="next page-numbers"><fa-icon [icon]="faChevronRight"></fa-icon></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image"></div>
    </div>
</section>
